<template>
    <div class="divisor">
        <div class="d-flex align-items-center justify-content-between w-100 mb-2">
            <div>
                <span :class="'txt-h-3 txt-blue-2 txt-size-'+iconSize" v-if="icon != null">
                    <i :class="icon"></i>
                </span>
                <span :class="'txt-h-3 txt-blue-2 txt-size-'+textSize" v-if="title != null">
                    {{title}}
                </span>
            </div>

            <slot name="verMais"></slot>
        </div>
        
        <div class="divisor-horizontal w-100"></div>
    </div>
</template>

<script>

    export default {
        name: 'Divisor',
        props: {
            icon: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            iconSize: {
                type: Number,
                default: 23,
            },
            textSize: {
                type: Number,
                default: 25,
            },
        },
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .divisor-horizontal {
        border-top: 1px solid color('blue','2');
    }
</style>

